import { JSX } from 'react';
import classNames from 'classnames';
import { styled } from '@mui/material/styles';

/** UnreadMessageIcon props (extends div attributes). */
export type IUnreadMessageIconProps = JSX.IntrinsicElements['div'];

/**
 * Icon indicating an unread message (coloured dot).
 *
 * **Behaviour:**
 * - A styled div that uses the `:before` pseudo-element to draw a circle (borderRadius 50%, size 0.5em) with colour `var(--breakline_color)`.
 * - Used in MessageFooter when the message is not in "read" state and hideRead is false.
 * - Accepts a `title` attribute (typically the localized "Unread" text) for the tooltip.
 *
 * @param {IUnreadMessageIconProps} props - className and div HTML attributes
 * @returns {JSX.Element} Div with unread indicator dot
 */
export const UnreadMessageIcon = styled(
	({ className, ...props }: IUnreadMessageIconProps) => (
		<div
			className={classNames(
				'message__unread-icon',
				'UnreadMessageIcon-unread-icon',
				className,
			)}
			{...props}
		/>
	),
	{ label: 'UnreadMessageIcon', target: 'UnreadMessageIcon-root' },
)({
	display: 'flex',
	color: 'var(--breakline_color)',
	'&:before': {
		content: '""',
		height: '0.5em',
		width: '0.5em',
		borderRadius: '50%',
		backgroundColor: 'var(--breakline_color)',
		display: 'inline',
		margin: '0 0.5em',
		alignItems: 'center',
	},
});
